(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("notations", [], factory);
	else if(typeof exports === 'object')
		exports["notations"] = factory();
	else
		root["notations"] = root["notations"] || {}, root["notations"]["DocsPage"] = factory();
})(this, () => {
return 